module.exports = __webpack_public_path__ + "static/Splits-b308c9712f95d63b39c8789bbeb58602.png";